import { AGREEMENT_STATE, ELECTRONIC_CONSENT_STATUS, ORDERS_STATUS } from 'Pages/orders_design'
import { Roles } from 'Constants/Roles'
import { SETTING_KEY_USER } from 'Modules'

export const STATUSES_FOR_REQUEST_LEAD = {
	[AGREEMENT_STATE.ARCHIVE]: [
		ELECTRONIC_CONSENT_STATUS.ARCHIVE,
		ELECTRONIC_CONSENT_STATUS.DELETED,
		ELECTRONIC_CONSENT_STATUS.NOT_ACTUAL,
		ELECTRONIC_CONSENT_STATUS.COMPLETED_NOT_ACTUAL,
		ELECTRONIC_CONSENT_STATUS.WITH_VIOLATION,
	],
	[AGREEMENT_STATE.ACTUAL]: [
		ELECTRONIC_CONSENT_STATUS.NEW,
		ELECTRONIC_CONSENT_STATUS.SENT,
		ELECTRONIC_CONSENT_STATUS.ACTIVATED,
		ELECTRONIC_CONSENT_STATUS.COMPLETED,
	],
	CONSENT_WAIT: [
		ELECTRONIC_CONSENT_STATUS.NEW,
		ELECTRONIC_CONSENT_STATUS.SENT,
		ELECTRONIC_CONSENT_STATUS.ACTIVATED,
	],
}

export const ORDERS_FOR_REQUEST_LEAD = {
	[AGREEMENT_STATE.ARCHIVE]: [ORDERS_STATUS.HAS_ORDER, ORDERS_STATUS.HAS_NO_ORDER],
	[AGREEMENT_STATE.ACTUAL]: [
		ORDERS_STATUS.HAS_ORDER,
		ORDERS_STATUS.HAS_NO_ORDER,
		ORDERS_STATUS.RESERV_AVAILABLE,
		ORDERS_STATUS.ORDER_AVAILABLE,
	],
}

export enum DELIVERY_TYPES {
	SMS = 'sms',
	EMAIL = 'email',
}

export enum DOC_TYPES {
	USER_PASSPORT_FULLS = 'user_passport_fulls',
	USTAVS = 'ustavs',
}

export const SETTINGS_KEY = SETTING_KEY_USER.ELECTRONIC_AGREEMENTS

export const VIEW_CHANGE_STATUS_ROLES = [
	Roles.ADMIN,
	Roles.SUPER_ADMIN,
	Roles.TECH_SUPPORT,
	Roles.QA_EXPERT,
	Roles.SECURITY,
]
